/* SHAZDE Motion v2 — site-wide reveals, hover polish, parallax, counters, transparent hero header.
   Newsletter-Popup: sections/shazde-popup.liquid. Kolibri-Hero-Animation entfernt.
   Respects prefers-reduced-motion. Buy box + trust tabs on product pages stay untouched. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var EXCLUDE =
    '#shopify-section-announcement-bar, .shopify-section-group-header-group, sticky-header, header, ' +
    '.slideshow, cart-drawer, .cart-drawer, .drawer, .cart-notification, ' +
    '[id*="__main"], [id*="a0102860"]';

  function isExcluded(el) {
    return !!el.closest(EXCLUDE);
  }

  /* ---------- 1. Auto-tag common theme elements for scroll reveal ---------- */
  function tagReveals() {
    var selectors = [
      '.image-with-text__content .image-content-wrapper > *',
      '.rich-text__blocks > *',
      '.multicolumn-list__item',
      '.card-wrapper',
      '.faq-content-wrap',
      '.footer-block',
      '.newsletter__wrapper > *',
      '.title-wrapper-with-link',
      '.section-title',
      '.collection-list__item',
      '.article-card'
    ];

    var els;
    try {
      els = document.querySelectorAll(selectors.join(','));
    } catch (e) {
      return;
    }

    els.forEach(function (el) {
      if (el.classList.contains('shazde-fade') || isExcluded(el)) return;
      el.classList.add('shazde-fade');
      var parent = el.parentElement;
      if (parent) {
        var i = Array.prototype.indexOf.call(parent.children, el);
        el.style.transitionDelay = Math.min(i, 5) * 90 + 'ms';
      }
    });
  }

  /* ---------- 2. Fade-in on scroll ---------- */
  function initFadeIns() {
    var targets = document.querySelectorAll('.shazde-fade');
    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- 3. Subtle parallax for large background images ---------- */
  function initParallax() {
    if (reduceMotion || window.innerWidth < 990) return;

    var imgs = [];
    document
      .querySelectorAll('[class*="shazde-stats-media-"] img, .banner__media img')
      .forEach(function (img) {
        if (isExcluded(img)) return;
        img.classList.add('shazde-parallax-img');
        imgs.push(img);
      });
    if (!imgs.length) return;

    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      imgs.forEach(function (img) {
        var host = img.closest('[class*="shazde-stats-"], .banner__media') || img;
        var rect = host.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        progress = Math.max(-1, Math.min(1, progress));
        img.style.transform = 'translateY(' + (progress * -26).toFixed(1) + 'px) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  /* ---------- 4. Legacy hero parallax hook ---------- */
  function initHeroParallax() {
    if (reduceMotion) return;
    var hero = document.querySelector('.shazde-hero-parallax-media');
    if (!hero) return;

    var ticking = false;
    function update() {
      var offset = window.scrollY;
      hero.style.transform = 'translateY(' + Math.min(offset * 0.18, 120) + 'px)';
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* ---------- 5. Animated counters ---------- */
  function initCounters() {
    var counters = document.querySelectorAll('.shazde-counter');
    if (!counters.length) return;

    function animateCounter(el) {
      var target = parseFloat(el.dataset.target || '0');
      var duration = 1600;
      var start = null;

      if (reduceMotion) {
        el.textContent = el.dataset.target;
        return;
      }

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target * eased;
        el.textContent = target % 1 === 0 ? Math.floor(value).toLocaleString('de-DE') : value.toFixed(1);
        if (progress < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      counters.forEach(animateCounter);
      return;
    }

    var counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    counters.forEach(function (el) { counterObserver.observe(el); });
  }

  /* ---------- 6. Transparent header over homepage hero ---------- */
  function initTransparentHeader() {
    if (!document.body.classList.contains('index')) return;
    var headerSection = document.getElementById('shopify-section-header');
    var hero = document.querySelector('.slideshow.banner--large');
    if (!headerSection || !hero) return;

    document.body.classList.add('shz-transparent-header');

    function setHeaderHeight() {
      document.documentElement.style.setProperty('--shz-header-h', headerSection.offsetHeight + 'px');
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    function onScroll() {
      document.body.classList.toggle('shz-header-solid', window.scrollY > 24);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAll() {
    tagReveals();
    initFadeIns();
    initParallax();
    initHeroParallax();
    initCounters();
    initTransparentHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();
